import { FormEvent, useMemo, useState } from "react";

import { SelectData } from "../../../../../../models";

interface UseSelectProjectsModalReturnData {
  projectsMultiSelectDataOrder: string[];
  open: boolean;
  onDropdownVisibleChange: (open: boolean) => void;
  closePanelAndDropdown: () => void;
  saveProjectsSelectDataAndCloseDropdown: (e: FormEvent<HTMLFormElement>) => void;
}

interface UseSelectProjectsModalProps {
  roadmapProjectUuids: string[];
  projectsMultiSelectData: SelectData | undefined;
  closePanel: () => void;
  onSaveProjectsSelectData: () => void;
}
export const useSelectProjectsModal = ({
  roadmapProjectUuids,
  projectsMultiSelectData,
  closePanel,
  onSaveProjectsSelectData,
}: UseSelectProjectsModalProps): UseSelectProjectsModalReturnData => {
  // Override default dropdown open state to get intended behaviour
  const [open, setOpen] = useState(false);
  const onDropdownVisibleChange = (_: boolean): void => {
    setOpen(true);
  };
  const closePanelAndDropdown = (): void => {
    setOpen(false);
    closePanel();
  };
  const saveProjectsSelectDataAndCloseDropdown = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    onSaveProjectsSelectData();
    setOpen(false);
  };

  const projectsMultiSelectDataOrder = useMemo<string[]>(() => {
    const notSelectedProjects =
      projectsMultiSelectData
        ?.filter((project) => !roadmapProjectUuids.includes(project.key as string))
        .map((project) => project.key as string) ?? [];

    return roadmapProjectUuids.concat(notSelectedProjects);
  }, [projectsMultiSelectData, roadmapProjectUuids]);

  return {
    projectsMultiSelectDataOrder,
    open,
    onDropdownVisibleChange,
    closePanelAndDropdown,
    saveProjectsSelectDataAndCloseDropdown,
  };
};
